import React from 'react';
import generateHreflang from 'lib/utils/generateHreflang';
import PATHS from 'lib/navigation/paths';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { mapNamedLocaleToLocale } from 'lib/data/localesMap';
import { defaultNS } from 'next-i18next.config';
import { SignInView } from 'views/user-module/SignInView';

const SignUpPage = () => (
  <>
    <SignInView />
  </>
);

export async function getServerSideProps(ctx) {
  const { locale } = ctx;
  const hreflangData = generateHreflang(PATHS.users.signIn().url, ctx.locale);

  if (ctx.req.method !== 'GET') {
    ctx.res.statusCode = 503;
    return { props: {} };
  }

  return {
    props: {
      ...(await serverSideTranslations(mapNamedLocaleToLocale[locale], [
        ...defaultNS,
        'fe_er_sign_up_page',
        'fe_er_common_registration_aside',
        'fe_er_sign_up_page',
        'fe_er_auth',
        'fe_er_common_app_ad_links',
        'fe_er_common_rewards_items_list',
      ])),
      hreflangData,
      options: {
        showCaptureEmailOverlay: false,
        showPendingReservationMessage: false,
      },
    },
  };
}
export default SignUpPage;
